import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LayoutDashboard, FileText, BarChart3, LogOut, Calendar, Bell, Settings, Users as UsersIcon, ClipboardList } from "lucide-react";

const BASE_NAV = [
    { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "nav-dashboard" },
    { to: "/contratos", label: "Contratos", icon: FileText, testid: "nav-contracts" },
    { to: "/relatorios", label: "Relatórios", icon: BarChart3, testid: "nav-reports" },
    { to: "/agenda", label: "Agenda", icon: Calendar, testid: "nav-agenda" },
    { to: "/issues", label: "Issues/Tasks", icon: ClipboardList, testid: "nav-issues" },
    { to: "/alertas", label: "Alertas", icon: Bell, testid: "nav-alerts" },
    { to: "/configuracoes", label: "Configurações", icon: Settings, testid: "nav-settings" },
];

const MASTER_ONLY = { to: "/usuarios", label: "Usuários", icon: UsersIcon, testid: "nav-users" };

export default function Layout({ children }) {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const isMaster = user?.role === "master" || user?.role === "admin";
    const NAV = isMaster ? [...BASE_NAV, MASTER_ONLY] : BASE_NAV;

    async function handleLogout() {
        await logout();
        navigate("/login");
    }

    return (
        <div className="min-h-screen flex bg-[#F4F6FA]">
            <aside className="w-64 flex-shrink-0 bg-[#0F2044] text-white min-h-screen fixed left-0 top-0 flex flex-col no-print" data-testid="sidebar">
                <div className="px-6 pt-7 pb-6 flex items-center gap-3 border-b border-white/10">
                    <div className="h-10 w-10 rounded-md bg-white flex items-center justify-center p-1">
                        <img src="/logo-licito.png" alt="licito.guru" className="h-full w-full object-contain" />
                    </div>
                    <div>
                        <div className="font-display font-bold text-base leading-tight">licito.guru</div>
                        <div className="text-[10px] uppercase tracking-[0.18em] text-white/60">CS Console</div>
                    </div>
                </div>
                <nav className="flex-1 px-3 py-5 space-y-1">
                    {NAV.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.end}
                            data-testid={item.testid}
                            className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
                        >
                            <item.icon className="h-4 w-4" strokeWidth={1.6} />
                            <span>{item.label}</span>
                        </NavLink>
                    ))}
                </nav>
                <div className="px-4 py-4 border-t border-white/10">
                    <div className="text-xs text-white/80 mb-0.5 font-semibold truncate" data-testid="sidebar-user-name">{user?.name || user?.email}</div>
                    <div className="text-[10px] uppercase tracking-[0.16em] text-white/40 mb-2" data-testid="sidebar-user-role">
                        {isMaster ? "Master" : "Operacional"}
                    </div>
                    <button
                        onClick={handleLogout}
                        data-testid="logout-button"
                        className="w-full flex items-center justify-center gap-2 text-xs font-medium text-white/80 hover:text-white border border-white/15 hover:border-white/30 rounded-md px-3 py-1.5 transition-colors"
                    >
                        <LogOut className="h-3.5 w-3.5" />
                        Sair
                    </button>
                </div>
            </aside>
            <main className="ml-64 flex-1 min-h-screen">
                <div className="px-10 py-8 max-w-[1400px]">
                    {children}
                </div>
            </main>
        </div>
    );
}
